import {
  PERIOD_ADMIN_SAVE_INIT,
  PERIOD_ADMIN_SAVE_SUCCESS,
  PERIOD_ADMIN_SAVE_FAILURE,
  PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY,
  PERIOD_ADMIN_SAVE_RESET,
  PERIOD_ADMIN_GET_PERIODS_LIST_INIT,
  PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS,
  PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE,
  PERIOD_ADMIN_SET_ACTIVE_PERIOD,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE,
  PERIOD_ADMIN_CLOSE_PERIOD_INIT,
  PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS,
  PERIOD_ADMIN_CLOSE_PERIOD_FAILURE,
  PERIOD_ADMIN_GET_GROUPS_INIT,
  PERIOD_ADMIN_GET_GROUPS_SUCCESS,
  PERIOD_ADMIN_GET_GROUPS_FAILURE,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE,
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT,
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS,
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE,
  PERIOD_ADMIN_IMPORT_INIT,
  PERIOD_ADMIN_IMPORT_SUCCESS,
  PERIOD_ADMIN_IMPORT_FAILURE,
  PERIOD_ADMIN_IMPORT_RESET,
  PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT,
  PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS,
  PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE,
  PERIOD_ADMIN_CALCULATE_INIT,
  PERIOD_ADMIN_CALCULATE_SUCCESS,
  PERIOD_ADMIN_CALCULATE_FAILURE,	
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS,
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE,
	PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT,
	PERIOD_ADMIN_DELETE_CALCULATION_INIT,
	PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS,
	PERIOD_ADMIN_DELETE_CALCULATION_FAILURE,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE,
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT,
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE,
  PERIOD_ADMIN_SOFT_RESET,
  PERIOD_ADMIN_RESET,
  PERIOD_ADMIN_GET_CUSTOMER_INIT,
  PERIOD_ADMIN_GET_CUSTOMER_SUCCESS,
  PERIOD_ADMIN_GET_CUSTOMER_FAILURE,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE,
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: PERIOD_ADMIN_RESET
  };
}

export function softReset() {
  return {
    type: PERIOD_ADMIN_SOFT_RESET
  };
}

export function getPeriodsList() {
  let params = {
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function setActivePeriod(period) {
  return {
    type: PERIOD_ADMIN_SET_ACTIVE_PERIOD,
    payload: {
      data: period
    }
  };
}

export function saveEntity(data) {
  data.period.timezone_offset = new Date().getTimezoneOffset();
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/save",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveEntityDataByKey(key, value) {
  return {
    type: PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveEntity(data) {
  return {
    type: PERIOD_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function changePeriodState(params) {
  params.timezone_offset = new Date().getTimezoneOffset();
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/changeperiodstate",
        "PUT",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE, error));
    }  
  };
}

export function closePeriod(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_CLOSE_PERIOD_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/closeperiod",
        "PUT",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_CLOSE_PERIOD_FAILURE, error));
    }  
  };
}

export function rollBackPeriod(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/rollbackperiod",
        "PUT",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE, error));
    }  
  };
}

export function getGroupsList(periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_GROUPS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_GROUPS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_GROUPS_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsList(keyword, groupId, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize,
    group_id: groupId
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE, error));
    }  
  };
}

export function getMetricsGroupsWithDefaults() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metricsgroup/getmetricsgroupswithdefaults",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE, error));
    }  
  };
}

export function downloadImportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/metric/downloadimportmetricdatafile",
        intl.formatMessage(
          { id: "common.entity.importFileName"}, 
          { entityNamePlural: intl.formatMessage({ id: "metricAdmin.entityNamePlural" } ) } 
        ),
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE, error));
    }  
  };
}

export function importEntities(files, params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_IMPORT_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/metric/importmetricdata",
        files,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_IMPORT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_IMPORT_FAILURE, error));
    }  
  };
}

export function getImportFilesList() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/getimportsfilelist",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE, error));
    }  
  };
}

export function resetImport() {
  return {
    type: PERIOD_ADMIN_IMPORT_RESET
  };
}

export function calculate(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_CALCULATE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/calculate",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_CALCULATE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_CALCULATE_FAILURE, error));
    }  
  };
}

export function getCalculationsHistory(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/calculations_history",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE, error));
    }  
  };
}
	
export function prepareDeleteCalculation(id) {
  return {
    type: PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT,
    id: id
  };
}
	
export function deleteCalculation(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_DELETE_CALCULATION_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_DELETE_CALCULATION_FAILURE, error));
    }  
  };
}

export function downloadCalculationReportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/downloadcalculationreportfile",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE, error));
    }  
  };
}

export function downloadCalculationUnifiedReportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/downloadcalculationunifiedreportfile",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE, error));
    }  
  };
}

export function getPolynomialsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active", "model", "exclude_from_ux_active_models_lists"],
    searches_are: [true, true, "false"],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE, error));
    }  
  };
}

export function getPolynomialsSubModelList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active", "sub_model", "exclude_from_ux_active_models_lists"],
    searches_are: [true, true, "false"],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE, error));
    }  
  };
}

export function getMetricsDataUploadInfo(params, index) {
  return async (dispatch) => {
    let actionToDispatchInit = ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT);
    actionToDispatchInit.index = index;
    dispatch(actionToDispatchInit);
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/getmetricsdatauploadinfo",
        "POST",
        null,
        params
      );
      let actionToDispatchSuccess = ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS, resp);
      actionToDispatchSuccess.index = index;
      dispatch(actionToDispatchSuccess);
    } catch (error) {
      let actionToDispatchFailure = ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE, error);
      actionToDispatchFailure.index = index;
      dispatch(actionToDispatchFailure);
    }  
  };
}

export function getProcessingMetricsImportsNotifications(periodId, page = 1) {
  let params = {
    period_id: periodId,
    order_fields: ["created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC],
    per_page: Constants.interface.notificationsPageSize,
    page: page
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getprocessingmetricsimportnotifications",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE, error));
    }  
  };
}

export function getBiTemplatesList(periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/bitemplate/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE, error));
    }  
  };
}

export function exportBiReports(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/bitemplate/export",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE, error));
    }  
  };
}

export function getPolynomialFilterTreeInfo(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/getpolynomialfiltertreeinfo",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE, error));
    }  
  };
}

export function getCustomer() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_GET_CUSTOMER_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getcustomer",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_GET_CUSTOMER_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_GET_CUSTOMER_FAILURE, error));
    }  
  }
}

export function refreshVirtualMetricData(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/refreshvirtualmetricdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE, error));
    }  
  }
}



// WEBPACK FOOTER //
// ./source/client/actions/periodAdmin/index.js